"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectEnvironment = exports.Environment = void 0;
const types_1 = require("@refinitiv-data/types");
const detect_browser_1 = require("detect-browser");
exports.Environment = types_1.Environment;
const detectEnvironment = () => {
    const env = (0, detect_browser_1.detect)();
    if (env && env.type === 'browser') {
        return types_1.Environment.WEB;
    }
    return types_1.Environment.NODEJS;
};
exports.detectEnvironment = detectEnvironment;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV0ZWN0LWVudmlyb25tZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWwvZGV0ZWN0LWVudmlyb25tZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUEyRDtBQUMzRCxtREFBd0M7QUFHM0IsUUFBQSxXQUFXLEdBQUcsbUJBQUcsQ0FBQztBQUV4QixNQUFNLGlCQUFpQixHQUFHLEdBQVEsRUFBRTtJQUN2QyxNQUFNLEdBQUcsR0FBRyxJQUFBLHVCQUFNLEdBQUUsQ0FBQztJQUVyQixJQUFJLEdBQUcsSUFBSSxHQUFHLENBQUMsSUFBSSxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ2hDLE9BQU8sbUJBQUcsQ0FBQyxHQUFHLENBQUM7SUFDbkIsQ0FBQztJQUVELE9BQU8sbUJBQUcsQ0FBQyxNQUFNLENBQUM7QUFDdEIsQ0FBQyxDQUFDO0FBUlcsUUFBQSxpQkFBaUIscUJBUTVCIn0=